import { useQuery } from "@tanstack/react-query";
import { auth } from "@mysnowscape/snow-lib";
import { CurrentUser } from "../store/storeTypes";

type UserCompaniesResponse = {
  userCompanies?: Array<{
    companyId: string;
    companyName: string;
    isPaid?: boolean;
  }>;
};

export type CompanyOption = {
  value: string;
  label: string;
};

/**
 * The companies the current user administers, as select options. The property
 * history page and its company filter both need this list: the filter to offer
 * the companies you can pick, the page to spell out "all of my companies" for
 * the export, which cannot send an empty list through its form post.
 */
export default function useAdminCompanyOptions(currentUser: CurrentUser): {
  companyOptions: CompanyOption[];
  companyIds: string[];
  isPending: boolean;
} {
  const companyQuery = useQuery<UserCompaniesResponse>({
    queryKey: ["user/" + currentUser.uid + "/companies"],
  });
  const companyOptions =
    companyQuery.data?.userCompanies
      ?.filter((c) => auth.canAdminCompany(currentUser, c.companyId))
      ?.map((c) => ({
        label: c.companyName + (c.isPaid ? "" : " (inactive)"),
        value: c.companyId,
      })) ?? [];

  return {
    companyOptions,
    companyIds: companyOptions.map((c) => c.value),
    isPending: companyQuery.isPending,
  };
}
